import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { ADMIN_USERS_ENDPOINTS, AdminUsersService } from "@/service/api/admin-users";
import { getApiErrorMessage } from "@/modules/common/utils/apiError";

const useCreateUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: AdminUsersService.createUser,
    onError: (error) => {
      toast.error(getApiErrorMessage(error, "Erro ao cadastrar usuário. Tente novamente mais tarde."), {
        toastId: "create_admin_user_error",
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ADMIN_USERS_ENDPOINTS.GET_USERS] });
      queryClient.invalidateQueries({ queryKey: [ADMIN_USERS_ENDPOINTS.GET_TOTALIZERS] });
    },
  });
};

export default useCreateUser;
